
    import tools from '@/api/tools.js';
    export default {
        data(){
            return {
            }
        }
        ,mounted(){
        }
        ,methods:{
            sitemap(){
                var url = './10_1.html';
                location.href = url;
            } 
            ,contact (){
                var url = './11_1.html';
                location.href = url;
            } 
            ,to_xzzbtb(){
                var url = 'https://www.xzzbtb.cn';
                location.href = url;
            }
        }
    }
